import { render, staticRenderFns } from "./ZonasSeguridad.vue?vue&type=template&id=9eff89f6"
import script from "./ZonasSeguridad.vue?vue&type=script&lang=js"
export * from "./ZonasSeguridad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports